import { L10n } from '../L10n/L10n';
import { IDataSourceBase } from '../models/IDataSourceInfo';
import { DataSources } from '../../content/resources/Datasources';
import { IError } from '../../httpClient/serverApi/types/IError';
import { RefreshModeTypes } from '../ServerApi/types/IRemoteRefreshProperties';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { ToasterService, ToastType } from './ToasterService';
import { Messages } from '../../codegen/Localize';
import {getSessionManagementServiceInstance} from '~src/sessionManagement/SessionManagementService';

 export namespace ChangeDatasourceRemoteAgentAction {

   export function execute(datasource: IDataSourceBase,
                           newRemoteAgentName: string,
                           currentRefreshMode: string,
                           suppressErrorToast: boolean,
                           workflowId?: string): Promise<IResult> {
    // If this no-op is changed, please check the logic for suppressSuccessToast at all call sites.
    if (currentRefreshMode !== RefreshModeTypes.Remote) {
      // no-op because the refresh mode isn't remote
      return Promise.resolve({});
    }

    return DataSources.setRemoteAgent(datasource.id, newRemoteAgentName, workflowId).then((result: IResult) => {
      const sessionManagementService = getSessionManagementServiceInstance();
      if (!suppressErrorToast && result.errors && result.errors.length) {
        ToasterService.instance.pop({ type: ToastType.Error, text: errorMessageFor(result.errors[0], datasource)});
      }

      if (!result.errors || !result.errors.length) {
        if (currentRefreshMode === RefreshModeTypes.Remote) {
          ToasterService.instance.pop({
            type: ToastType.Success,
            text: this.successMessageFor(newRemoteAgentName)
          });
        } else {
          if(sessionManagementService.isOnlineEnvironment()) {
            ToasterService.instance.pop({
              type: ToastType.Success,
              text: Messages.editRemoteRefreshPropertiesServerSuccess()
            });
          }
        }
      }

      return result;
    });

  }

  function errorMessageFor(error: IError, datasource: IDataSourceBase) {
    switch (error.code) {
      default:
        return Messages.errorUnknown();
    }
  }
  export function successMessageFor(newRemoteAgentName: string): string {
    return Messages.editRemoteRefreshPropertiesAgentSuccess({AGENT_NAME: L10n.elideIfLong(newRemoteAgentName)});
  }
}

export type ChangeDatasourceRemoteAgentAction = typeof ChangeDatasourceRemoteAgentAction;